import RedeemMethodSelection from './RedeemMethodSelection';

export default RedeemMethodSelection;
